import { MORE_768_MEDIA_QUERY } from '../../../../../consts/adaptive';
import { defaultTheme } from 'sletat-ui-components2/dist/theme';
import { cssToObject } from '../../../../../../utils/cssToObject';

export const styles = {
    infoRow: {
        display: 'flex',
        flexFlow: 'column nowrap',
        justifyContent: 'space-between',
    },
    paramColumn: {
        display: 'flex',
        flexDirection: 'column',
        width: '100%',
    },
    paramName: {
        ...cssToObject(defaultTheme.theme.mixin.fontCaptionM_Caps),
        color: defaultTheme.theme.colorVariables.textNoteDark,
        margin: '0 0 0.25rem 0',
    },
    param: {
        margin: '0 0 0.75rem 0',
    },
    paramValue: {
        ...cssToObject(defaultTheme.theme.mixin.fontTextXS),
        color: defaultTheme.theme.colorVariables.textDark,
        margin: 0,
    },
    facilityPlaceholder: {
      ...cssToObject(defaultTheme.theme.mixin.fontTextXS),
      color: defaultTheme.theme.colorVariables.textNoteDark,
    },

    [MORE_768_MEDIA_QUERY]: {
      infoRow: {
        flexFlow: 'row nowrap',
    },
      paramColumn: {
          width: 'calc(50% - 0.75rem)',
      },
      param: {
        '&:last-child': {
          margin: 0,
        }
      },
    }
};

export type ComponentJSSClasses = JSSClasses<typeof styles>;
